var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.vuex_h5)?_c('pageHeader'):_vm._e(),(_vm.vuex_h5)?_c('pageHeaderMobile'):_vm._e(),_c('div',{staticClass:"layout-box"},[_c('router-view')],1),_c('pageFooter'),_c('goTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }